export class FreespinsActions {
    static ActionStart: string = "FREESPIN_START";
    static ActionBack: string = "FREESPIN_BACK_TO_GAME";
    static ActionSpin: string = "FREESPIN_SPIN";
    static ActionSpinStop: string = "FREESPIN_SPIN_STOP";
    static ActionAutoplay: string = "FREESPIN_AUTOPLAY";
    static ActionAutoplayStop: string = "FREESPIN_AUTOPLAY_STOP";
    static ActionSkipWin: string = "FREESPIN_SKIP_WIN";
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Actions/FreespinsActions.ts
 **/